import * as React from "react";
import { StatsLegendItem } from "..";
import { ScoreboardIconsOrdered } from "../../../../constants";
export class ScoreboardInfo extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-aggregate-stats-info" },
            React.createElement("button", { className: "rj-aggregate-stats-info-button", onClick: this.props.slideDown },
                React.createElement("span", { className: "icon i-12 rj-aggregate-stats-arrow-up" })),
            React.createElement("div", { className: "rj-aggregate-stats-info-text" }, this.props.dict.legendText),
            React.createElement("div", { className: "rj-aggregate-stats-info-legend" }, Object.keys(ScoreboardIconsOrdered).map(k => (React.createElement(StatsLegendItem, { dict: this.props.dict, key: `key-${k}`, text: k, iconClass: ScoreboardIconsOrdered[k] }))))));
    }
}
//# sourceMappingURL=ScoreboardInfo.js.map